<p-dialog
  [appendTo]="'body'"
  [ngClass]="{ 'fixed left-0 top-0 z-50 h-full w-full bg-black bg-opacity-10 backdrop-blur-sm': visible }"
  [(visible)]="visible"
  [style]="{ width: '50rem', height: '28rem', margin: '0 2rem 0 2rem' }">
  <ng-template pTemplate="headless">
    <div class="grid h-full w-full grid-cols-1 md:grid-cols-6 grid-rows-6 gap-4 rounded-lg bg-gray-100">

      <div class="order-2 md:order-1 col-span-1 md:col-span-3 row-span-6 flex flex-col justify-center gap-4 px-8 mb-3 md:mb-0">
        <div class="text-center text-lg font-bold text-gray-500">
          <div [innerHTML]="pre_tittle"></div>
        </div>
        <div class="text-center text-xl md:text-3xl font-black text-primary-500">
          <div [innerHTML]="title_text"></div>
        </div>
        <div class="text-center text-gray-500">
          <div [innerHTML]="body_text"></div>
        </div>
      </div>

      <div class="order-1 md:order-2 relative col-span-1 md:col-span-3 md:col-start-4 row-span-6">
        <i
          class="pi pi-times absolute right-2 top-2 cursor-pointer text-2xl text-gray-100 contrast-50"
          (click)="close()"></i>
        <img [src]="image_url" alt="logo-tolis" class="h-full w-full rounded-lg object-cover" />
      </div>

    </div>
  </ng-template>
</p-dialog>
